import { render, staticRenderFns } from "./jy-outboundPickDetail2.vue?vue&type=template&id=087e1074&scoped=true&"
import script from "./jy-outboundPickDetail2.vue?vue&type=script&lang=js&"
export * from "./jy-outboundPickDetail2.vue?vue&type=script&lang=js&"
import style0 from "./jy-outboundPickDetail2.vue?vue&type=style&index=0&id=087e1074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e1074",
  null
  
)

export default component.exports